'use client';

import { useEffect, type ReactElement } from 'react';

import './globals.css';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: Props): ReactElement {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body className="bg-bg text-ink">
        <div className="relative flex min-h-screen items-center justify-center px-6">
          <div className="bg-surface-elevated/70 ring-border-subtle relative z-10 w-full max-w-md overflow-hidden rounded-3xl p-8 text-center shadow-2xl ring-1 backdrop-blur-xl">
            <h1 className="text-ink text-3xl font-semibold tracking-tight">
              Falha crítica no Trakd
            </h1>
            <p className="text-ink-muted mt-3 text-sm">
              Um erro inesperado interrompeu o carregamento. Nossa equipe já foi avisada.
            </p>
            {error.digest ? (
              <p className="text-ink-muted/70 mt-4 font-mono text-xs">ref: {error.digest}</p>
            ) : null}
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => reset()}
                className="bg-trakd-brand inline-flex h-10 items-center justify-center rounded-full px-5 text-sm font-semibold text-white transition hover:brightness-110"
              >
                Tentar novamente
              </button>
              <a
                href="/"
                className="bg-surface/60 text-ink border-border-subtle hover:bg-surface inline-flex h-10 items-center justify-center rounded-full border px-5 text-sm font-medium backdrop-blur-xl transition"
              >
                Voltar pra home
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
